import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from '@xstate/react';
import MULTI_PAYMENT_FLOW_TABS from '../../const/multiPaymentFlowTabs';
import MainContext from '../../Context';
import normalizeStaticHostName from '../../helpers/normalizeStaticHostName';
import { ApiProvider } from '../../hooks/machines/useApiMachine';
import useMainMachine from '../../hooks/machines/useMainMachine';
import { PaymentFlowProvider } from '../../hooks/machines/usePaymentFlowMachine';
import { useContextAtom } from '../../store/jotaiCoreAtoms';
import { useShowCloseInterstitial } from '../../store/multiPaymentAtoms';
import { MAPFlowTypes } from '../../typings/deepLink';
import { MakeAPaymentView, useCurrentViewAtom } from '../../store/currentViewAtom';
import { ContentWrapper } from '../atoms/styled/ContentWrapper';
import CloseInterstitial from './DigitalCollections/MultiPaymentFlow/CloseInterstitial';
import JotaiCore from './JotaiCore';
import XStateCore from './XStateCore';
const CoreWrapper = ({ accountId, accountLast4, additionalProps, apiConfig, featureFlags, handleClose, handleCloseOnConversion, headerRef, helpNumber, hosts, isOpen, triggerAnalyticsEvent }) => {
    const [multiPaymentFlowCurrentTab, setMultiPaymentFlowCurrentTab] = useState(additionalProps.flow.type === 'MULTI_PAYMENT_FLOW'
        ? MULTI_PAYMENT_FLOW_TABS.MULTI
        : MULTI_PAYMENT_FLOW_TABS.ONE_TIME);
    const [, setContext] = useContextAtom();
    const [showCloseInterstitial, setShowCloseConfirmationAtom] = useShowCloseInterstitial();
    const [, currentViewReducer] = useCurrentViewAtom();
    const baseContext = useMemo(() => ({
        apiConfig,
        featureFlags,
        handleClose,
        handleCloseOnConversion,
        helpNumber,
        isOpen,
        additionalProps,
        multiPaymentFlowCurrentTab,
        triggerAnalyticsEvent
    }), [
        apiConfig,
        handleCloseOnConversion,
        handleClose,
        helpNumber,
        isOpen,
        additionalProps,
        multiPaymentFlowCurrentTab,
        featureFlags,
        triggerAnalyticsEvent
    ]);
    const [{ context: { apiMachineRef } }, sendToMainMachine, mainService] = useMainMachine(baseContext);
    const mainContextValues = useMemo(() => (Object.assign(Object.assign({}, baseContext), { multiPaymentFlowCurrentTab,
        accountId,
        accountLast4,
        sendToMainMachine, staticHostName: normalizeStaticHostName(hosts), triggerAnalyticsEvent })), [
        accountId,
        accountLast4,
        baseContext,
        multiPaymentFlowCurrentTab,
        hosts,
        sendToMainMachine,
        triggerAnalyticsEvent
    ]);
    useEffect(() => {
        setContext(mainContextValues);
    }, [mainContextValues, setContext]);
    const mainMachineState = useSelector(mainService, (state) => state);
    const { currentPaymentFlow } = mainMachineState.context;
    const handleTabSwitch = (index) => {
        currentViewReducer({
            type: 'updateView',
            view: MakeAPaymentView.MultiPaymentDetails
        });
        setMultiPaymentFlowCurrentTab(index);
        if (mainMachineState.matches('open.managePaymentMethod')) {
            sendToMainMachine({
                type: 'GO_TO_PAYMENT_FLOW'
            });
        }
    };
    const hasCurrentPaymentFlowInitialized = currentPaymentFlow[0] === 'oneTime';
    const handleRejectClose = () => {
        setShowCloseConfirmationAtom(false);
    };
    return (_jsxs(MainContext.Provider, Object.assign({ value: mainContextValues }, { children: [showCloseInterstitial && (_jsx(CloseInterstitial, { onAccept: handleClose, onReject: handleRejectClose, onSwitchTab: handleTabSwitch })), !showCloseInterstitial && isOpen && (_jsx(ContentWrapper, { children: _jsx(ApiProvider, Object.assign({ value: apiMachineRef }, { children: additionalProps.flow.type === MAPFlowTypes.MULTI_PAYMENT_FLOW &&
                        hasCurrentPaymentFlowInitialized ? (_jsx(PaymentFlowProvider, Object.assign({ value: currentPaymentFlow }, { children: _jsx(JotaiCore, { handleClose: handleClose, handleTabSwitch: handleTabSwitch, headerRef: headerRef, mainService: mainService }) }))) : (_jsx(XStateCore, { headerRef: headerRef, mainService: mainService })) })) }))] })));
};
export default CoreWrapper;
